<div class="boxWhite">
    <h4>CAMBIAR SUCURSAL CB</h4>

    <button class="btn btnClose" (click)="close()">
        <img src="assets/img/icoClose.svg" alt="">
    </button>

    <div class="contModal">
        <div class="row">
            <div class="col-sm-6">
                <h6 class="clBlack">ID CB</h6>
                <p class="clGray mb-4">{{jornada?.conductor.visibleId}}</p>
            </div>
            <div class="col-sm-6">
                <h6 class="clBlack">nombre conductor</h6>
                <p class="clGray mb-4">{{jornada?.conductor.nombres}} {{jornada?.conductor.apellidoPaterno}}</p>
            </div>
        </div>

        <div class="row">
            <div class="col-sm-12">
                <div class="boxInsideModal bgLightGray mb-4 d-flex align-items-center justify-content-between">
                    <div class="d-flex flex-column justify-content-center">
                        <h6>SUCURSAL ORIGEN</h6>
                        <p class="clLightBlue m-0 fw-medium">{{jornada?.sucursal?.nombre}}</p>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-sm-12 mb-4">
                <!--<select class="form-select">
                    <option selected disabled>Seleccione estado</option>
                </select>-->
                <ng-select placeholder="SELECCIONE TERMINAL" [(ngModel)]="sucursalSeleccionada" [multiple]="false" bindLabel="nombre" [items]="listadoSucursalesDisponibles">
                </ng-select>
            </div>
        </div>



    </div>


    <div class="footModal">
        <button *ngIf="tienePermisoCambiarSucursalCB()" class="btn btnBlue w-100" (click)="putActualizarSucursalJornada()">CAMBIAR SUCURSAL</button>
    </div>


</div>
